var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductTypes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product Types"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/task-square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "task-square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3394 8.14001H16.1519",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.84814 8.14001L6.53564 8.82751L8.59814 6.76501",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.3394 14.5567H16.1519",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.84814 14.5567L6.53564 15.2442L8.59814 13.1817",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.25016 20.1667H13.7502C18.3335 20.1667 20.1668 18.3333 20.1668 13.75V8.25001C20.1668 3.66668 18.3335 1.83334 13.7502 1.83334H8.25016C3.66683 1.83334 1.8335 3.66668 1.8335 8.25001V13.75C1.8335 18.3333 3.66683 20.1667 8.25016 20.1667Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductTypes);
export default __webpack_public_path__ + "static/media/product-types.849e12cb45d25fc481246b0232a95f79.svg";
export { ForwardRef as ReactComponent };